import React from 'react';
import PropTypes from 'prop-types';

import { StyledHeader, StyledHeaderCell } from './styled';

const TableHeader = ({ tableCellsConfig }) => {
  return (
    <StyledHeader>
      {tableCellsConfig.map(({ header = null, props = {}, headerProps = {} }, key) => (
        <StyledHeaderCell {...props} {...headerProps} key={key}>
          {header}
        </StyledHeaderCell>
      ))}
    </StyledHeader>
  );
};

TableHeader.propTypes = {
  tableCellsConfig: PropTypes.array,
};

const tableHeaderHeight = 21;

export default TableHeader;
export { tableHeaderHeight };
